var map = {
	"./Arrow": 24951,
	"./Arrow.vue": 24951,
	"./ArrowDown": 96690,
	"./ArrowDown.vue": 96690,
	"./ArrowUp": 99774,
	"./ArrowUp.vue": 99774,
	"./close.svg": 48298,
	"./full-screen.svg": 42154,
	"./hyperlink.svg": 9220,
	"./lock-orange.png": 65554,
	"./lock.png": 4085,
	"./online_only.png": 8632,
	"./onsite+online.png": 31602,
	"./pdf.svg": 39392,
	"./recording.png": 33383,
	"./unlocked-black.png": 43661,
	"./unlocked.png": 62359,
	"./wait.gif": 47992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;